// // import React, { useState, useEffect } from 'react';
// // import { Link, useLocation } from 'react-router-dom';
// // import { Menu, X, Search, Globe } from 'lucide-react';

// // const Header = () => {
// //   const [isMenuOpen, setIsMenuOpen] = useState(false);
// //   const [scrolled, setScrolled] = useState(false);
// //   const location = useLocation();

// //   useEffect(() => {
// //     const handleScroll = () => {
// //       setScrolled(window.scrollY > 50);
// //     };
// //     window.addEventListener('scroll', handleScroll);
// //     return () => window.removeEventListener('scroll', handleScroll);
// //   }, []);

// //   // Close mobile menu when route changes
// //   useEffect(() => {
// //     setIsMenuOpen(false);
// //   }, [location]);

// //   const navLinks = [
// //     { name: 'HOME', path: '/' },
// //     { name: 'ABOUT', path: '/about' },
// //     { name: 'SERVICES', path: '/services' },
// //     { name: 'CONTACT', path: '/contact' }
// //   ];

// //   const isActive = (path) => {
// //     return location.pathname === path;
// //   };

// //   return (
// //     <nav className={`fixed w-full z-50 transition-all duration-300 ${
// //       scrolled ? 'bg-white shadow-lg' : 'bg-white/95 backdrop-blur-sm'
// //     }`}>
// //       <div className="container mx-auto px-6 py-4">
// //         <div className="flex justify-between items-center">
// //           {/* Logo */}
// //           <Link to="/" className="flex items-center space-x-3">
// //             <div className="w-10 h-10 bg-gradient-to-br from-cyan-400 to-blue-500 rounded-lg flex items-center justify-center">
// //               <Globe className="w-6 h-6 text-white" />
// //             </div>
// //             <span className="text-3xl font-bold tracking-tight">aigency</span>
// //           </Link>

// //           {/* Desktop Menu */}
// //           <div className="hidden lg:flex items-center space-x-8">
// //             {navLinks.map((link) => (
// //               <Link
// //                 key={link.path}
// //                 to={link.path}
// //                 className={`relative text-sm font-medium transition ${
// //                   isActive(link.path)
// //                     ? 'text-black'
// //                     : 'text-gray-700 hover:text-black'
// //                 }`}
// //               >
// //                 {isActive(link.path) && (
// //                   <span className="absolute inset-0 bg-black rounded-full -z-10"></span>
// //                 )}
// //                 <span className={`${
// //                   isActive(link.path) 
// //                     ? 'bg-black text-white px-6 py-2.5 rounded-full inline-block' 
// //                     : ''
// //                 }`}>
// //                   {link.name}
// //                 </span>
// //                 {!isActive(link.path) && link.name !== 'CONTACT' && ' ▼'}
// //               </Link>
// //             ))}
// //           </div>

// //           {/* Right Side Buttons */}
// //           <div className="flex items-center space-x-4">
// //             <Search className="w-5 h-5 text-gray-700 cursor-pointer hover:text-black hidden lg:block" />
// //             <Link 
// //               to="/contact"
// //               className="bg-gradient-to-r from-cyan-400 to-blue-500 text-white px-8 py-3 rounded-full font-medium hover:shadow-xl transition transform hover:scale-105 hidden lg:block"
// //             >
// //               GET IN_TOUCH
// //             </Link>
// //             <button 
// //               onClick={() => setIsMenuOpen(!isMenuOpen)} 
// //               className="lg:hidden"
// //             >
// //               {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
// //             </button>
// //           </div>
// //         </div>

// //         {/* Mobile Menu */}
// //         {isMenuOpen && (
// //           <div className="lg:hidden mt-4 pb-4 space-y-4 border-t pt-4 animate-fade-in">
// //             {navLinks.map((link) => (
// //               <Link
// //                 key={link.path}
// //                 to={link.path}
// //                 className={`block py-2 transition ${
// //                   isActive(link.path)
// //                     ? 'text-cyan-500 font-semibold'
// //                     : 'text-gray-700 hover:text-black'
// //                 }`}
// //               >
// //                 {link.name}
// //               </Link>
// //             ))}
// //             <Link 
// //               to="/contact"
// //               className="w-full bg-gradient-to-r from-cyan-400 to-blue-500 text-white px-8 py-3 rounded-full font-medium text-center block"
// //             >
// //               GET IN_TOUCH
// //             </Link>
// //           </div>
// //         )}
// //       </div>

// //       <style jsx>{`
// //         @keyframes fade-in {
// //           from {
// //             opacity: 0;
// //             transform: translateY(-10px);
// //           }
// //           to {
// //             opacity: 1;
// //             transform: translateY(0);
// //           }
// //         }

// //         .animate-fade-in {
// //           animation: fade-in 0.3s ease-out;
// //         }
// //       `}</style>
// //     </nav>
// //   );
// // };

// // export default Header;


// import React, { useState, useEffect } from 'react';
// import { Link, useLocation } from 'react-router-dom';
// import { Menu, X, Search, Globe } from 'lucide-react';

// const Header = () => {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [scrolled, setScrolled] = useState(false);
//   const location = useLocation();

//   useEffect(() => {
//     const handleScroll = () => {
//       setScrolled(window.scrollY > 50);
//     };
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   // Close mobile menu when route changes
//   useEffect(() => {
//     setIsMenuOpen(false);
//   }, [location]);

//   const navLinks = [
//     { name: 'HOME', path: '/' },
//     { name: 'ABOUT', path: '/about' },
//     { name: 'SERVICES', path: '/services' },
//     { name: 'CONTACT', path: '/contact' }
//   ];

//   const isActive = (path) => {
//     return location.pathname === path;
//   };

//   return (
//     <nav className={`fixed w-full top-0 left-0 z-50 transition-all duration-300 ${
//       scrolled ? 'bg-white shadow-lg' : 'bg-white/95 backdrop-blur-sm'
//     }`} style={{ margin: 0, padding: 0 }}>
//       <div className="container mx-auto px-6 py-4">
//         <div className="flex justify-between items-center">
//           {/* Logo */}
//           <Link to="/" className="flex items-center space-x-3">
//             <div className="w-10 h-10 bg-gradient-to-br from-cyan-400 to-blue-500 rounded-lg flex items-center justify-center">
//               <Globe className="w-6 h-6 text-white" />
//             </div>
//             <span className="text-3xl font-bold tracking-tight">aigency</span>
//           </Link>

//           {/* Desktop Menu */}
//           <div className="hidden lg:flex items-center space-x-8">
//             {navLinks.map((link) => (
//               <Link
//                 key={link.path}
//                 to={link.path}
//                 className={`relative text-sm font-medium transition ${
//                   isActive(link.path)
//                     ? 'text-black'
//                     : 'text-gray-700 hover:text-black'
//                 }`}
//               >
//                 {isActive(link.path) && (
//                   <span className="absolute inset-0 bg-black rounded-full -z-10"></span>
//                 )}
//                 <span className={`${
//                   isActive(link.path) 
//                     ? 'bg-black text-white px-6 py-2.5 rounded-full inline-block' 
//                     : ''
//                 }`}>
//                   {link.name}
//                 </span>
//                 {!isActive(link.path) && link.name !== 'CONTACT' && ' ▼'}
//               </Link>
//             ))}
//           </div>

//           {/* Right Side Buttons */}
//           <div className="flex items-center space-x-4">
//             <Search className="w-5 h-5 text-gray-700 cursor-pointer hover:text-black hidden lg:block" />
//             <Link 
//               to="/contact"
//               className="bg-gradient-to-r from-cyan-400 to-blue-500 text-white px-8 py-3 rounded-full font-medium hover:shadow-xl transition transform hover:scale-105 hidden lg:block"
//             >
//               GET IN_TOUCH
//             </Link>
//             <button 
//               onClick={() => setIsMenuOpen(!isMenuOpen)} 
//               className="lg:hidden"
//             >
//               {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
//             </button>
//           </div>
//         </div>

//         {/* Mobile Menu */}
//         {isMenuOpen && (
//           <div className="lg:hidden mt-4 pb-4 space-y-4 border-t pt-4 animate-fade-in">
//             {navLinks.map((link) => (
//               <Link
//                 key={link.path}
//                 to={link.path}
//                 className={`block py-2 transition ${
//                   isActive(link.path)
//                     ? 'text-cyan-500 font-semibold'
//                     : 'text-gray-700 hover:text-black'
//                 }`}
//               >
//                 {link.name}
//               </Link>
//             ))}
//             <Link 
//               to="/contact"
//               className="w-full bg-gradient-to-r from-cyan-400 to-blue-500 text-white px-8 py-3 rounded-full font-medium text-center block"
//             >
//               GET IN_TOUCH
//             </Link>
//           </div>
//         )}
//       </div>

//       <style jsx>{`
//         @keyframes fade-in {
//           from {
//             opacity: 0;
//             transform: translateY(-10px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }

//         .animate-fade-in {
//           animation: fade-in 0.3s ease-out;
//         }
//       `}</style>
//     </nav>
//   );
// };

// export default Header;


import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Search, Globe } from 'lucide-react';
import logo from './Assets/ChatGPT Image Jan 21, 2026, 06_32_21 PM.png';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  const navLinks = [
    { name: 'HOME', path: '/' },
    { name: 'ABOUT', path: '/about' },
    { name: 'SERVICES', path: '/services' },
    { name: 'CONTACT', path: '/contact' }
  ];

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <nav className={`fixed w-full top-0 left-0 z-50 transition-all duration-300 ${
      scrolled ? 'bg-white shadow-lg' : 'bg-white/95 backdrop-blur-sm'
    }`} style={{ margin: 0, padding: 0 }}>
      <div className="container mx-auto px-6 py-4">
        <div className="flex justify-between items-center">
          {/* Logo - Version 1: Stacked Text Style */}
          <Link to="/" className="flex items-center space-x-3 group">
            {/* Logo Image */}
           <div className="relative">
  <img 
    src={logo} 
    alt="Savera Tech Solutions Logo" 
    className="h-16 w-16 object-contain rounded-xl bg-white p-1 
               transition-transform duration-300 group-hover:scale-110"
    onError={(e) => {
      e.target.style.display = 'none';
      e.target.nextElementSibling.style.display = 'flex';
    }}
  />
              {/* Fallback Icon */}
              <div className="hidden w-12 h-12 bg-gradient-to-br from-cyan-400 to-blue-500 rounded-xl items-center justify-center shadow-lg">
                <Globe className="w-7 h-7 text-white" />
              </div>
            </div>
            
            {/* Company Name - Stacked */}
            <div className="flex flex-col">
              <span className="text-2xl font-bold bg-gradient-to-r from-cyan-500 to-blue-600 bg-clip-text text-transparent tracking-tight leading-tight">
                Saveratech
              </span>
              <span className="text-sm font-semibold text-gray-600 tracking-wide -mt-1">
                SOLUTIONS
              </span>
            </div>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`relative text-sm font-medium transition ${
                  isActive(link.path)
                    ? 'text-black'
                    : 'text-gray-700 hover:text-black'
                }`}
              >
                {isActive(link.path) && (
                  <span className="absolute inset-0 bg-black rounded-full -z-10"></span>
                )}
                <span className={`${
                  isActive(link.path) 
                    ? 'bg-black text-white px-6 py-2.5 rounded-full inline-block' 
                    : ''
                }`}>
                  {link.name}
                </span>
                {!isActive(link.path) && link.name !== 'CONTACT' && ' ▼'}
              </Link>
            ))}
          </div>

          {/* Right Side Buttons */}
          <div className="flex items-center space-x-4">
            <Search className="w-5 h-5 text-gray-700 cursor-pointer hover:text-black hidden lg:block" />
            <Link 
              to="/contact"
              className="bg-gradient-to-r from-cyan-400 to-blue-500 text-white px-8 py-3 rounded-full font-medium hover:shadow-xl transition transform hover:scale-105 hidden lg:block"
            >
              GET IN_TOUCH
            </Link>
            <button 
              onClick={() => setIsMenuOpen(!isMenuOpen)} 
              className="lg:hidden"
            >
              {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 space-y-4 border-t pt-4 animate-fade-in">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`block py-2 transition ${
                  isActive(link.path)
                    ? 'text-cyan-500 font-semibold'
                    : 'text-gray-700 hover:text-black'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link 
              to="/contact"
              className="w-full bg-gradient-to-r from-cyan-400 to-blue-500 text-white px-8 py-3 rounded-full font-medium text-center block"
            >
              GET IN_TOUCH
            </Link>
          </div>
        )}
      </div>

      <style jsx>{`
        @keyframes fade-in {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-fade-in {
          animation: fade-in 0.3s ease-out;
        }
      `}</style>
    </nav>
  );
};

export default Header;